<template>
	<div class="page">
		<div class="pageTitleBox">
			<div class="boxNameL">
				新建
			</div>
			<div class="boxNameR">
				<!-- <el-button type="warning" @click="$router.back()" size="small">保存</el-button> -->
				<el-button type="warning" @click="$router.back()" size="small">返回</el-button>
			</div>
		</div>
		<div class="content">
			<div class="tit">
				<div >
					属性
				</div>
				<div>
				</div>
			</div>
			<el-form class="demo-form-inline" ref="form" label-width="formLabelWidth">
				<el-row>
					<el-col :span="24" >
						<el-form-item label="症状分类：" :label-width="formLabelWidth" prop="nick_name">
							<span v-for="(item,index) in threeTag.parent_all" :key="index">
								{{item.name}} - 
							</span>
							{{threeTag.name}}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div class="tit" style="margin:25px 0 15px;">
				<div >
					适用药
				</div>
				<div>
					<el-button type="text" icon="el-icon-plus" size="mini" style="padding:0;color:#5E7BFA;" @click="dialogAddGoods_state=true">添加药品</el-button>
				</div>
			</div>
			<el-table :data="goodsList" style="width: 100%" ref = 'table1' row-class-name="row-expand-cove">
				<el-table-column prop="title" label="药品名称" min-width="150" :key="Math.random()">
					<template slot-scope="scope">
						<div v-if="$public.isNull(scope.row.cover)">{{scope.row.title}}</div>
						<el-tooltip v-else placement="top" effect="light">
							<div slot="content">
								<img :src="scope.row.cover"  style="width:300px;"/>
							</div>
							<div>{{scope.row.title}}</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column label="品牌" min-width="70">
					<template slot-scope="scope">
						<span>{{scope.row.brand_name}}</span>
					</template>
				</el-table-column>
				<el-table-column label="分类" min-width="70">
					<template slot-scope="scope">
						<span>{{scope.row.category_info.name}}</span>
					</template>
				</el-table-column>
				<el-table-column label="规格" min-width="70">
					<template slot-scope="scope">
						<span>{{scope.row.old_packinfo_info.sku_value}}</span>
					</template>
				</el-table-column>
				<el-table-column label="单价" min-width="70">
					<template slot-scope="scope">
						<span>{{scope.row.pprice}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="70">
					<template slot-scope="scope">
						<el-button type="text" size="mini" @click="del(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBox">
				<page style="padding:10px 0;" :total="page.total" :page="page.pageIndex" @change="changePage"></page>
			</div>
		</div>
		<div v-if="dialogAddGoods_state">
			<dialogAddShop :addShopState="dialogAddGoods_state" :shopId="curShopId" :tree="[{id:'602f1e88c904d9db7ccf3bec',children:[{id:'602f1e88c904d9db7ccf3bed'},{id:'602f1e89c904d9db7ccf3bf6'},{id:'602f1e89c904d9db7ccf3bfc'},{id:'602f1e89c904d9db7ccf3bff'}]}]" @submit="submit_dialogAddGoods" @closeOn="dialogAddGoods_state=false"></dialogAddShop>
		</div>
	</div>
</template>

<script>
	import page from "../../../components/page.vue"
	import dialogAddShop from "../../../components/dialog_addShop.vue"
	export default {
		components:{dialogAddShop,page},
		data() {
			return {
				
				formLabelWidth: '110px',
				
				threeTag:{},
				
				goodsList:[],
				page:{
					pageIndex:1,
					pageSize:10,
					total:0,
				},
				
				// 添加药品
				dialogAddGoods_state:false,
				
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		mounted() {
			this.threeTag = JSON.parse(sessionStorage.getItem('midicineSecondTag'))
			this.getGoodsList()
		},
		methods: {
			// 添加药品
			submit_dialogAddGoods({goodsItem,skuItem,wayItem,goodsType}){
				console.log(goodsItem,skuItem,wayItem,goodsType)
				let params = {
					"id": goodsItem.medical_id,
					"label": [{
						"code": this.threeTag.parent_all[0].custom_code,
						"name": this.threeTag.parent_all[0].name,
						"subs": [{
							"code": this.threeTag.parent_all[1].custom_code,
							"name": this.threeTag.parent_all[1].name,
							subs:[{
								"code": this.threeTag.custom_code,
								"name": this.threeTag.name,
							}]
						}]
					}]
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_Url_baseData+'/api/product/medical/update/tag', params).then(res => {
					loading.close()
					if(res.code===0){
						this.$message({
							message: '添加成功',
							type: 'success'
						});
						this.page.pageIndex = 1;
						this.getGoodsList()
					}
				})
			},
			// 删除
			del(row){
				console.log(row)
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						"id": row.medical_id,
						"label": this.threeTag.custom_code,
					}
					let loading = this.$loading()
					this.$http.post(process.env.VUE_APP_Url_baseData+'/api/product/medical/delete/tag', params).then(res => {
						loading.close()
						if(res.code===0){
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getGoodsList()
						}
					})
				})
			},
			// 分页
			changePage(num){
				this.page.pageIndex = num;
				this.getGoodsList()
			},
			getGoodsList(){
				let params = {
					"pageIndex": this.page.pageIndex,
					"pageSize": this.page.pageSize,
					"keyword": "",
					"categoryId": "",
					"shopId": "",
					"status": "",
					"stockStatus": -1,
					"applyType": -1,
					"tagCode": this.threeTag.custom_code,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_Url_baseData+'/api/product/medical/list', params).then(res => {
					loading.close()
					if(res.code===0){
						this.goodsList = res.data.data
						this.page.total = res.data.count
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		.content {
			background-color: #fff;padding:30px 0;
			.tit{
				font-size: 16px;color:$fontColor;font-weight: bold;border-left:5px solid $mainColor;padding-left:16px;display: flex;justify-content: space-between;padding-right: 20px;
			}
			::v-deep .el-form{
				padding-top:10px;
				.el-form-item{
					margin-bottom:0px;padding-top:10px;
				}
			}
		}
	}
</style>
